// extracted by mini-css-extract-plugin
export default {"cell":"AvailabilityCell-cell_tOzH1"};